import { useLogs } from '../../../hooks/server/useLogsViewer.js';
import SearchBar from '../../../components/utils/SearchBar.jsx';
import LogsTable from '../../../components/tables/server/LogsTable.jsx';
import Pagination from '../../../components/utils/Pagination.jsx';
import SuccessModal from '../../../components/modales/SuccessModal.jsx';
import ErrorModal from '../../../components/modales/ErrorModal.jsx';

const ListLogs = () => {
    const {
        logs,
        // búsqueda
        searchTerm,
        setSearchTerm,
        // paginación
        currentPage,
        setCurrentPage,
        itemsPerPage,
        // acciones
        handleDownload,
        // feedback
        error,
        success,
        setError,
        setSuccess,
        loading
    } = useLogs();

    // FILTRO
    const filteredLogs = logs.filter(log =>
        log.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // PAGINACIÓN
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentLogs = filteredLogs.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <>
            <div className='container mt-6'>
                <h1 className='text-center'>Logs del sistema</h1>
                <SearchBar 
                    searchTerm={searchTerm} 
                    handleSearchChange={e => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                    }}
                />

                {/* Componentes */}
                <LogsTable
                    logs={currentLogs}
                    handleDownload={handleDownload}
                    currentPage={currentPage}
                    itemsPerPage={itemsPerPage}
                />
                <Pagination
                    itemsPerPage={itemsPerPage}
                    totalItems={filteredLogs.length}
                    currentPage={currentPage}
                    paginate={setCurrentPage}
                />

                {/* Modales */}
                {error && (
                    <ErrorModal show={!!error} message={error} onClose={() => setError('')} />
                )}
                {success && (
                    <SuccessModal show={!!success} message={success} onClose={() => setSuccess('')} />
                )}
                {loading && 
                    <div className="text-center mt-6">
                        <div className="spinner-grow text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                }
            </div>
        </>
    );
};

export default ListLogs;